import { CountFrequency } from '../FinancialForensics.types';
import { TimeSeriesEntry } from './EmployeeCount.types';

export interface Detail {
  type: string;
  values: TimeSeriesEntry[];
  label?: string;
  isSum?: boolean;
}

export interface FeeCalculation {
  detailsType: CountFrequency | undefined;
  details: Detail[];
}

export type EntryType =
  | 'Regular'
  | 'Other'
  | 'Reimbursement'
  | 'Recovery'
  | 'Rebate';

export interface VendorEntry {
  vendorID: string;
  claims: string;
  value: number;
  entryType: EntryType;
  feeCalculation: FeeCalculation;
  isChosen: boolean;
  capFee: number;
  flatFee: number;
}

export interface PlanContribution {
  fees: VendorEntry[];
  rebates: VendorEntry[];
}

export interface VariableCost {
  planContribution: PlanContribution;
  memberContribution: VendorEntry[];
}

const emptyFeeCalculation = (): FeeCalculation => ({
  detailsType: undefined,
  details: [],
});

export const emptyVendorEntry = (): VendorEntry => ({
  vendorID: '',
  claims: '',
  value: 0,
  entryType: 'Regular',
  feeCalculation: emptyFeeCalculation(),
  isChosen: false,
  capFee: 0,
  flatFee: 0,
});

export const getEmptyVariableCost = (): VariableCost => ({
  planContribution: {
    fees: [],
    rebates: [],
  },
  memberContribution: [],
});
